
import { atom } from "recoil";

const timeState =atom({
    key: 'time',
    default: 'no'
})

export default timeState